import { styled } from '@mui/material'
import type React from 'react'

type BadgeColor = 'primary' | 'error'

const Badge = styled('span', {
  shouldForwardProp: (prop) => prop !== 'badgeColor',
})<{ badgeColor: BadgeColor }>(({ theme, badgeColor }) => ({
  alignItems: 'center',
  background: theme.palette[badgeColor].main,
  borderRadius: 99,
  color: theme.palette[badgeColor].contrastText,
  display: 'inline-flex',
  fontSize: '1.1rem',
  fontWeight: 700,
  height: 18,
  justifyContent: 'center',
  lineHeight: 1,
  minWidth: 18,
  padding: theme.spacing(0, 0.75),
}))

export interface NavUnreadBadgeProps {
  count: number
  /** Teal by default; `error` for counts that are late (overdue reminders). */
  color?: BadgeColor
}

/** Count pill on a nav item: unread messages, queue backlog, overdue reminders. */
export const NavUnreadBadge: React.FC<NavUnreadBadgeProps> = ({ count, color = 'primary' }) => (
  <Badge badgeColor={color}>{count > 99 ? '99+' : count}</Badge>
)

export default NavUnreadBadge
